module.exports = __webpack_public_path__ + "img/logo_mf.647ed043.png";